import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './About.css';

import ceoImage from '../../assets/kamal.png';
import hospitalphoto from '../../assets/hospital.jpg';
import ceoImagee from '../../assets/dr.jpeg';

const About = () => {
  return (
    <div className="about-page">

      {/* ✅ SEO START */}
      <Helmet>
        <title>About Amaanat IVF | Best IVF Centre in Ambala</title>

        <meta
          name="description"
          content="Learn about Amaanat IVF Clinic in Ambala, led by experienced fertility specialists offering IVF, ICSI, and IUI treatments with high success rates."
        />

        <link rel="canonical" href="https://amaanativf.com/about" />

        {/* ✅ Organization + Founder Schema (NO UI CHANGE) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalOrganization",
            "name": "Amaanat IVF",
            "url": "https://amaanativf.com",
            "founder": {
              "@type": "Person",
              "name": "Dr. Harjeet Kaur"
            },
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Ambala",
              "addressRegion": "Haryana",
              "addressCountry": "India"
            }
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* Hero */}
      <section className="about-hero">
        <div className="container">
          <h1 className="hero-title">About Amaaat IVF in Ambala</h1>
          <p className="hero-subtitle">
            Excellence in fertility care and IVF treatment
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="story-section">
        <div className="container">
          <div className="story-content">

            <div className="story-text">
              <h2>Our IVF Journey</h2>

              <p>
                Our clinic has been at the forefront of fertility treatments in Ambala.
                We have grown into a trusted IVF center serving patients across North India.
              </p>

              <p>
                We combine advanced IVF technology with compassionate care to help
                couples achieve their dream of parenthood.
              </p>
            </div>

            <div className="story-image">
              <img
                src={hospitalphoto}
                alt="Amaanat IVF Clinic in Ambala"
                loading="lazy"
              />
            </div>

          </div>
        </div>
      </section>

      {/* Founder Section (UNCHANGED CONTENT) */}
      <section className="ceo-section">
        <div className="container">

          <h2 className="section-title">Meet Our Founder</h2>

          <div className="ceo-profile">

            <div className="ceo-image">
              <img
                src={ceoImagee}
                alt="Dr. Harjeet Kaur IVF Specialist"
                loading="lazy"
              />
            </div>

            <div className="ceo-details">

              <h3>Dr. Harjeet Kaur</h3>

              <p className="ceo-title">
                Founder, Medical Director & Chief Embryologist
              </p>

              <p className="ceo-bio">
                Dr. Harjeet Kaur is the Founder, Medical Director & Chief Embryologist at Amaanat IVF & Fertility, with over 12 years of extensive experience in IVF and embryology. She has successfully handled 10,000+ cases, reflecting her dedication and consistency in this field.

              </p>



              <p className="ceo-bio">
                Prior to establishing Amaanat IVF, she worked for over 10 years at Aashakiran IVF as a Chief Embryologist, where she gained vast experience in managing complex fertility cases and laboratory processes.

              </p>

              <p className="ceo-bio">
                Along with her technical expertise, she is highly experienced in patient counselling, helping couples understand their fertility journey with clarity, confidence, and emotional support.

              </p>
          <p className='ceo-bio'>
Known for her ethical approach, precision, and patient-focused care, she ensures personalized attention and transparent guidance throughout the journey.


          </p>
              <p className="ceo-vision">
                "Her vision is to build a center that combines trust, care, and high standards."
              </p>

            </div>
          </div>
        </div>
      </section>

      {/* Co-Founder Section (UNCHANGED CONTENT) */}
      <section className="ceo-section">
        <div className="container">

          <div className="ceo-profile">

            <div className="ceo-image">
              <img
                src={ceoImage}
                alt="Kamal Kartik Director Amaanat IVF"
                loading="lazy"
              />
            </div>

            <div className="ceo-details">

              <h3>Mr. Kamal Kartik</h3>

              <p className="ceo-title">
                Co-Founder, Director – Operations & Marketing
              </p>

              <p className="ceo-bio">
Kamal Kartik serves as the Co-Founder and Director – Operations & Marketing at Amaanat IVF & Fertility, where he plays a key role in ensuring the smooth functioning and growth of the center.
              

              </p>



              <p className="ceo-bio">
               
He is actively involved in managing daily operations, planning strategies, and strengthening the center’s outreach and visibility. His approach focuses on creating a well-organized system while maintaining a patient-friendly and supportive environment.

              </p>
<p className="ceo-bio">
He contributes significantly to building the brand presence, coordinating activities, and ensuring seamless communication across all levels.


</p>
<p className="ceo-bio">
With a strong focus on consistency, efficiency, and growth, Kamal Kartik helps in creating a structured and reliable system that supports both the team and patients effectively.

</p>
              <p className="ceo-vision">
                "His dedication and practical approach play an important role in enhancing the overall patient experience and expanding the reach of Amaanat IVF & Fertility"
              </p>

            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="mission-section">
        <div className="container">

          <h2 className="section-title">Our IVF Mission & Values</h2>

          <div className="values-grid">

            <div className="value-card">
              <h3>Excellence</h3>
              <p>High success rates using advanced IVF technology</p>
            </div>

            <div className="value-card">
              <h3>Compassion</h3>
              <p>Personalized fertility care for every patient</p>
            </div>

            <div className="value-card">
              <h3>Innovation</h3>
              <p>Latest IVF techniques and research</p>
            </div>

            <div className="value-card">
              <h3>Expertise</h3>
              <p>Experienced IVF specialists and embryologists</p>
            </div>

          </div>

        </div>
      </section>

    </div>
  );
};

export default About;